import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Confirmation } from '@portal-shared/app/models/confirmation.model';
import { ConfirmationService } from '@portal-shared/app/services/confirmation.service';
import { PortalDraggingService } from '@portal-shared/app/services/portal-dragging.service';
import { PlanningBoardPeriodService } from '@services/planning-board-period.service';
import { DragDropPayload } from './models/drag-drop-payload.model';
import { DragOverPayload } from './models/drag-over-payload.model';
import { PlanningGridTransactionService } from './planning-grid-transaction.service';

@Injectable({
  providedIn: 'root'
})
export class DraggingService extends PortalDraggingService<DragDropPayload, DragOverPayload> {
  public constructor(
    private planningTrxService: PlanningGridTransactionService,
    private planningBoardPeriodService: PlanningBoardPeriodService,
    private confirmationService: ConfirmationService,
    private translateService: TranslateService
  ) {
    super();
  }

  public async confirmRowDragIfNeeded(resourceName: string) {
    const userAccepts = await this.confirmationService.confirm(
      new Confirmation({
        messageKey: 'resource-management.planningBoard.errors.rowDrag',
        messageParams: { resourceName },
        confirmKey: 'resource-management.planningBoard.errors.rowDragConfirm'
      })
    );
    return userAccepts;
  }
}
